import React, { useEffect, useRef } from 'react'
import './cursor.css'

// Curseur custom : un petit point qui suit la souris au plus près,
// et un anneau plus large qui suit avec un léger retard (lerp).
// Grossit au survol des éléments interactifs (liens, boutons, cartes).
export default function CustomCursor() {
  const dotRef = useRef(null)
  const ringRef = useRef(null)
  const raf = useRef(null)

  useEffect(() => {
    const isFinePointer = window.matchMedia('(pointer: fine)').matches
    if (!isFinePointer) return

    document.body.classList.add('has-custom-cursor')

    const dot = dotRef.current
    const ring = ringRef.current

    let mouseX = window.innerWidth / 2
    let mouseY = window.innerHeight / 2
    let ringX = mouseX
    let ringY = mouseY

    const onMove = (e) => {
      mouseX = e.clientX
      mouseY = e.clientY
      dot.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0) translate(-50%, -50%)`
    }

    const onDown = () => ring.classList.add('is-clicking')
    const onUp = () => ring.classList.remove('is-clicking')

    const interactiveSelector = 'a, button, .card, .nav-link, .nav-cta, .btn, [data-cursor-hover]'
    const onOver = (e) => {
      if (e.target.closest && e.target.closest(interactiveSelector)) {
        ring.classList.add('is-hovering')
      }
    }
    const onOut = (e) => {
      if (e.target.closest && e.target.closest(interactiveSelector)) {
        ring.classList.remove('is-hovering')
      }
    }

    const tick = () => {
      ringX += (mouseX - ringX) * 0.15
      ringY += (mouseY - ringY) * 0.15
      ring.style.transform = `translate3d(${ringX}px, ${ringY}px, 0) translate(-50%, -50%)`
      raf.current = requestAnimationFrame(tick)
    }

    window.addEventListener('mousemove', onMove)
    window.addEventListener('mousedown', onDown)
    window.addEventListener('mouseup', onUp)
    document.addEventListener('mouseover', onOver)
    document.addEventListener('mouseout', onOut)
    raf.current = requestAnimationFrame(tick)

    return () => {
      document.body.classList.remove('has-custom-cursor')
      window.removeEventListener('mousemove', onMove)
      window.removeEventListener('mousedown', onDown)
      window.removeEventListener('mouseup', onUp)
      document.removeEventListener('mouseover', onOver)
      document.removeEventListener('mouseout', onOut)
      cancelAnimationFrame(raf.current)
    }
  }, [])

  return (
    <>
      <div ref={dotRef} className="cursor-dot" aria-hidden="true"></div>
      <div ref={ringRef} className="cursor-ring" aria-hidden="true"></div>
    </>
  )
}
